var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgWaveform = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H7V17H5V7ZM1 10H3V14H1V10ZM9 2H11V22H9V2ZM13 9H15V15H13V9ZM17 7H19V17H17V7ZM21 10H23V14H21V10Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgWaveform);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waveform.74400b50d339217def8c863dabd43a8d.svg";